import { render, staticRenderFns } from "./3ctext_jcfy.vue?vue&type=template&id=66f33800&scoped=true&"
import script from "./3ctext_jcfy.vue?vue&type=script&lang=js&"
export * from "./3ctext_jcfy.vue?vue&type=script&lang=js&"
import style0 from "./3ctext_jcfy.vue?vue&type=style&index=0&id=66f33800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f33800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f33800')) {
      api.createRecord('66f33800', component.options)
    } else {
      api.reload('66f33800', component.options)
    }
    module.hot.accept("./3ctext_jcfy.vue?vue&type=template&id=66f33800&scoped=true&", function () {
      api.rerender('66f33800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/myinfo/3ctext_jcfy.vue"
export default component.exports